import React from "react";

export default function TermsContent() {
  return (
    <div className="space-y-6 text-[#3a4d6b] leading-relaxed text-[15px]">
      <section>
        <h4 className="font-serif text-2xl text-[#1a2c4e] mb-2">Terms of Use</h4>
        <p>
          All use of this website, www.hbhslaw.com, is subject to the following Terms and Conditions. If you do not agree with these Terms and Conditions, please do not access or use this website. These terms are subject to change by HBHS at any time, without notice. Your use of the website constitutes your agreement to be bound by these terms.
        </p>
      </section>

      <section>
        <h4 className="font-serif text-2xl text-[#1a2c4e] mb-2">Terms and Conditions</h4>
      </section>

      <section>
        <h5 className="font-semibold italic text-[#1a2c4e] mb-2">Disclaimer</h5>
        <p className="mb-3">
          The materials provided on this site are for information purposes only. These materials constitute general information relating to areas of law familiar to our firm&rsquo;s attorneys. They do <strong>NOT</strong> constitute legal advice or other professional advice and you may not rely on the contents of this website as such, nor do they necessarily represent the opinions of HBHS, its attorneys or its clients.
        </p>
        <p>
          If you require legal advice, you should retain competent legal counsel to advise you. If you would like to retain HBHS, please contact one of our lawyers, who will be pleased to discuss whether our firm can assist you. An attorney-client relationship will arise between you and our firm only if we specifically agree to act for you. Until we specifically agree to act for you on a matter, you should not provide us with any confidential information or material.
        </p>
      </section>

      <section>
        <h5 className="font-semibold italic text-[#1a2c4e] mb-2">Confidentiality of Communications</h5>
        <p className="mb-3">
          HBHS does not guarantee the confidentiality of any communications sent by e-mail or through its website, or left in voice mail messages on firm telephones. Unsolicited information and material may not be treated as confidential and will not be protected by any attorney-client privilege. Accessing or using this website does not create an attorney-client relationship. Although the use of the website may facilitate access to or communications with members of HBHS by e-mail or voicemail, receipt of any such communications or transmissions by any member of HBHS does not create an attorney-client relationship, unless our firm agrees to represent you.
        </p>
        <p className="mb-3">
          Although HBHS has made reasonable efforts to ensure that the materials contained on this site are accurate, it does not warrant or guarantee: the accuracy, currency or completeness of the materials; that the site will be available without interruption, error or omission; that defects will be corrected; or that the website and the server(s) that make it available are free from viruses or harmful components.
        </p>
        <p>
          The website and the materials provided on the website are provided &ldquo;as is,&rdquo; without representations, warranties or conditions of any kind, either expressed or implied.
        </p>
      </section>
    </div>
  );
}
